import { render, staticRenderFns } from "./OrderConfig.vue?vue&type=template&id=312d8143&scoped=true&"
import script from "./OrderConfig.vue?vue&type=script&lang=js&"
export * from "./OrderConfig.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfig.vue?vue&type=style&index=0&id=312d8143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d8143",
  null
  
)

export default component.exports